import React, { useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useLanguage } from "./context/LanguageContext";
import Driver from "./pages/Driver";
import DriverRequirments from "./pages/DriverRequirments";
import Rider from "./pages/Rider";
import Places from "./pages/Places";
import Help from "./pages/Help";
import HelpBerymo from "./pages/HelpBerymo";
import HelpDriver from "./pages/HelpDriver";
import HelpRider from "./pages/HelpRider";
import Signup from "./pages/Singup";
import Safety from "./footer/Safety";
import DiverSafety from './footer/DiverSafety';
import BecomeaPartnerPlace from "./footer/BecomeaPartnerPlace";
import Aboutus from "./footer/Aboutus";
import Careers from "./footer/Careers";
import Legal from "./footer/Legal";
import PackageDelivery from "./footer/PackageDelivery";
import Legals from "./footer/Legals";
import DiningTerm from "./footer/DiningTerm";
import TermsofUse from "./footer/TermsofUse";
import TermsofUses from "./footer/TermsofUses";
import Accessibility from "./footer/Accessibility";
import Accessibilitys from "./footer/Accessibilitys";
import Independent from "./footer/Independent";
import Independents from "./footer/Independents";
import PartnerPlacesAgreement from "./footer/PartnerPlacesAgreement";
import PartnerPlacesAgreements from "./footer/PartnerPlacesAgreements";
import DiningTerms from "./footer/DiningTerms";
import FindaCity from "./pages/FindaCity";
import logo from "./logo.svg";
import "./styles/App.css";
import NotAvailable from "./cities/NotAvailable";
import Available from "./cities/Available";

// Newsletter Components
import Newsletter from "./components/Newsletter";
import NewsletterButton from "./components/NewsletterButton";
import Footer from "./components/Footer";
import ChatUs from "./components/ChatUs";
import Cities from "./footer/CitiesPage";
import CitiesPage from "./footer/CitiesPage";

import Pricing from "./pages/Pricing";
import LiveLocation from "./pages/LiveLocation";


// 1. IMPORT NEW COMPONENTS HERE (Assuming they exist in the same folder as their singular counterparts)
import Safetys from './footer/Safetys'; // New component
import Drivers from './footer/Drivers'; // New component
import Riders from './footer/Riders';
import BecomeaPartnerPlaces from './footer/BecomeaPartnerPlaces'; // New component
import PackageDeliverys from './footer/PackageDeliverys';
import DriverSafetys from './footer/DriverSafetys';
import Chatbot from "./components/Chatbot";

// END NEW IMPORTS

const LANGUAGES = [
  { code: 'en', label: 'English',    native: 'English',    flag: '🇺🇸' },
  { code: 'es', label: 'Spanish',    native: 'Español',    flag: '🇲🇽' },
  { code: 'pt', label: 'Portuguese', native: 'Português',  flag: '🇧🇷' },
  { code: 'fr', label: 'French',     native: 'Français',   flag: '🇫🇷' },
  { code: 'zh', label: 'Chinese',    native: '中文',        flag: '🇨🇳' },
  { code: 'hi', label: 'Hindi',      native: 'हिन्दी',      flag: '🇮🇳' },
  { code: 'te', label: 'Telugu',     native: 'తెలుగు',     flag: '🇮🇳' },
];

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const CheckIcon = () => (
  <svg className="lang-option-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

function AppWrapper() {
return (
<App />
);
}

function App() {
const { language, setLang, toggleLanguage, t } = useLanguage();
const location = useLocation();
const isNotAvailable = location.pathname.startsWith("/NotAvailable");
const isLegals = location.pathname === "/Legals";
const isDiningTerm = location.pathname === "/DiningTerm";
const isTermsofUses = location.pathname === "/TermsofUses";
const isAccessibilitys = location.pathname === "/Accessibilitys";
const isIndependents = location.pathname === "/Independents";
const isDriverRequirments = location.pathname === "/DriverRequirments";
const isPartnerPlacesAgreements = location.pathname === "/PartnerPlacesAgreements";

// 2. ADD NEW ROUTE EXCEPTION STATE VARIABLES HERE
const isSafetys = location.pathname === "/Safetys";
const isDriverSafetys = location.pathname === "/DriverSafetys";
const isDrivers = location.pathname === "/drivers";
const isRiders = location.pathname === "/Riders";
// CORRECTED THE PATH MATCH TO /PackageDeliverys
const isPackageDeliverys = location.pathname === "/PackageDeliverys";
const isBecomeaPartnerPlaces = location.pathname === "/BecomeaPartnerPlaces";
const isLiveLocation = location.pathname.startsWith("/live-location/") || location.pathname.startsWith("/livelocation/");
// END NEW STATE VARIABLES

const [showSignup, setShowSignup] = useState(false);
const [showMenu, setShowMenu] = useState(false);
const [showLangMenu, setShowLangMenu] = useState(false);

// Newsletter state
const [showNewsletter, setShowNewsletter] = useState(false);

const toggleMenu = () => {
setShowMenu(!showMenu);
setShowSignup(false);
};

const handleSignupClick = () => {
setShowSignup(!showSignup);
setShowMenu(false);
};

const handleNavClick = () => {
setShowMenu(false);
setShowSignup(false);
};

// Newsletter handlers
const handleOpenNewsletter = () => {
setShowNewsletter(true);
};

const handleCloseNewsletter = () => {
setShowNewsletter(false);
};
// 4. UPDATE CONDITIONAL RENDERING LOGIC FOR NAVBAR AND FOOTER
const shouldRenderNavAndFooter = !(
isNotAvailable ||
isLegals ||
isDiningTerm ||
isTermsofUses ||
isAccessibilitys ||
isIndependents ||
isPartnerPlacesAgreements ||
isDriverRequirments ||
isSafetys ||
isDrivers ||
isRiders ||
isDriverSafetys||
isPackageDeliverys || // **UPDATED to correctly check for /PackageDeliverys**
isBecomeaPartnerPlaces ||
isLiveLocation
);
// END CONDITIONAL RENDERING LOGIC UPDATE

return (
<>
{showSignup && <Signup onClose={() => {
setShowSignup(false);
}} />}

{shouldRenderNavAndFooter && (
<nav className="site-header">
<div className="header-shell">
<div className="header-left">
<a href="/" className="brand-link" aria-label="Berymo home">
<img className="brand-logo" src={logo} alt="Berymo Logo" />
</a>
<div className="header-links">
<a href="/Rider">{t.nav.rider}</a>
<a href="/Driver">{t.nav.driver}</a>
<a href="/Places">{t.nav.places}</a>
</div>
</div>

<div className="header-actions">
<a className="header-link" href="/Help">{t.nav.help}</a>
<a className="header-link" href="/FindaCity">{t.nav.findCity}</a>
<a className="header-phone" href="tel:+18664237966">
<span className="phone-label">Call</span>
<span className="phone-number">+1 (866) 423-7966</span>
</a>
<button type="button" className="lang-switcher-btn" onClick={() => setShowLangMenu(true)} aria-label="Select language">
  <GlobeIcon />
  {(LANGUAGES.find(l => l.code === language) || LANGUAGES[0]).code.toUpperCase()}
</button>
<button type="button" className="header-cta" onClick={() => setShowSignup(true)}>
{t.nav.signUp}
</button>
</div>

<div className="header-mobile">
<button type="button" className="header-ghost" onClick={handleSignupClick}>
{t.nav.signUp}
</button>
<button
type="button"
className={`menu-button ${showMenu ? "open" : ""}`}
onClick={toggleMenu}
aria-expanded={showMenu}
>
<span className="menu-text">
Menu
</span>
<span className="menu-bars" aria-hidden="true">
<span />
<span />
<span />
</span>
</button>
</div>
</div>

<div className={`header-panel ${showMenu ? "active" : ""}`}>
<div className="panel-inner">
<a href="/Rider" onClick={handleNavClick}>{t.nav.rider}</a>
<a href="/Driver" onClick={handleNavClick}>{t.nav.driver}</a>
<a href="/Places" onClick={handleNavClick}>{t.nav.places}</a>
<a href="/Help" onClick={handleNavClick}>{t.nav.help}</a>
<a href="/FindaCity" onClick={handleNavClick}>{t.nav.findCity}</a>
<button type="button" className="lang-switcher-btn" onClick={() => setShowLangMenu(true)} aria-label="Select language">
  <GlobeIcon />
  {(LANGUAGES.find(l => l.code === language) || LANGUAGES[0]).code.toUpperCase()}
</button>
<button
type="button"
className="panel-cta"
onClick={() => {
setShowSignup(true);
handleNavClick();
}}
>
{t.nav.signUp}
</button>
<a className="panel-phone" href="tel:+18664237966">
Call +1 (866) 423-7966
</a>
</div>
</div>
<Chatbot/>

{showLangMenu && (
  <div className="lang-modal-overlay" onClick={() => setShowLangMenu(false)}>
    <div className="lang-modal" onClick={e => e.stopPropagation()}>
      <button type="button" className="lang-modal-close" onClick={() => setShowLangMenu(false)} aria-label="Close">
        ✕
      </button>
      <h2 className="lang-modal-title">Select your preferred language</h2>
      <div className="lang-modal-grid">
        {LANGUAGES.map((lng) => (
          <button
            key={lng.code}
            type="button"
            className={`lang-modal-option${language === lng.code ? ' active' : ''}`}
            onClick={() => { setLang(lng.code); setShowLangMenu(false); }}
          >
            {lng.native}
          </button>
        ))}
      </div>
    </div>
  </div>
)}
</nav>
)}

<Routes>
<Route path="/" element={<Places />} />
<Route path="/Rider" element={<Rider />} />
<Route path="/Driver" element={<Driver />} />
<Route path="/DriverRequirments" element={<DriverRequirments />} />
<Route path="/Places" element={<Places />} />
<Route path="/Help" element={<Help />} />
<Route path="/HelpBerymo" element={<HelpBerymo />} />
<Route path="/HelpDriver" element={<HelpDriver />} />
<Route path="/HelpRider" element={<HelpRider />} />
<Route path="/FindaCity" element={<FindaCity />} />
<Route path="/Safety" element={<Safety />} />
<Route path="/DiverSafety" element={<DiverSafety />} />
<Route path="/DriverSafetys" element={<DriverSafetys />} />
<Route path="/BecomeaPartnerPlace" element={<BecomeaPartnerPlace />} />
<Route path="/Aboutus" element={<Aboutus />} />
<Route path="/Careers" element={<Careers />} />
<Route path="/Legal" element={<Legal />} />
<Route path="/Legals" element={<Legals />} />
<Route path="/PackageDelivery" element={<PackageDelivery />} />
<Route path="/privacy" element={<Legal />} />
<Route path="/privacy" element={<Legals />} />
<Route path="/TermsofUse" element={<TermsofUse />} />
<Route path="/TermsofUses" element={<TermsofUses />} />
<Route path="/Accessibility" element={<Accessibility />} />
<Route path="/Accessibilitys" element={<Accessibilitys />} />
<Route path="/Independent" element={<Independent />} />
<Route path="/Independents" element={<Independents />} />
<Route path="/DiningTerm" element={<DiningTerm />} />
<Route path="/partnerPlacesAgreement" element={<PartnerPlacesAgreement />} />
<Route path="/partnerPlacesAgreements" element={<PartnerPlacesAgreements />} />
<Route path="/DiningTerms" element={<DiningTerms />} />
<Route path="/NotAvailable/:cityName" element={<NotAvailable />} />
<Route path="/Available/:cityName" element={<Available />} />
<Route path="/Cities" element={<CitiesPage/>}/>

<Route path="/pricing" element={<Pricing />} />

<Route path="/livelocation/:rideId" element={<LiveLocation />} />
<Route path="/live-location/:shareToken" element={<LiveLocation />} />

{/* 3. ADD NEW ROUTES HERE */}
<Route path="/Safetys" element={<Safetys />} />
<Route path="/drivers" element={<Drivers />} />
<Route path="/Riders" element={<Riders />} />
<Route path="/BecomeaPartnerPlaces" element={<BecomeaPartnerPlaces />} />
<Route path="/PackageDeliverys" element={<PackageDeliverys />} />
{/* END NEW ROUTES */}
</Routes>

{shouldRenderNavAndFooter && (
<Footer />
)}

{/* Newsletter Components */}
{shouldRenderNavAndFooter && (
<>
{/* <NewsletterButton onClick={handleOpenNewsletter} />
<Newsletter isOpen={showNewsletter} onClose={handleCloseNewsletter} /> */}
{/* <ChatUs/> */}
</>
)}
</>
);
}

export default AppWrapper;
